"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var serverRouteModules_exports = {};
__export(serverRouteModules_exports, {
  getRouteExports: () => getRouteExports
});
module.exports = __toCommonJS(serverRouteModules_exports);
var import_routeExportsFromEntry = require("../server/routeExportsFromEntry");
var import_toAbsolute = require("../utils/toAbsolute");
var serverEntries = /* @__PURE__ */ new Map();
function loadServerEntry(serverEntry) {
  var loading = serverEntries.get(serverEntry);
  if (!loading) {
    loading = import((0, import_toAbsolute.toAbsoluteUrl)(serverEntry));
    serverEntries.set(serverEntry, loading);
  }
  return loading;
}
async function getRouteExports(serverEntry, routerRoot, routeFile) {
  var entry = await loadServerEntry(serverEntry);
  var exported = await (0, import_routeExportsFromEntry.getRouteExportsFromEntry)(entry, routerRoot, routeFile);
  if (!exported) {
    var _ref;
    var _entry_default_options, _entry_default, _entry_default_default_options, _entry_default_default, _entry_default1;
    var routes = (_ref = entry === null || entry === void 0 ? void 0 : (_entry_default = entry.default) === null || _entry_default === void 0 ? void 0 : (_entry_default_options = _entry_default.options) === null || _entry_default_options === void 0 ? void 0 : _entry_default_options.routes) !== null && _ref !== void 0 ? _ref : entry === null || entry === void 0 ? void 0 : (_entry_default1 = entry.default) === null || _entry_default1 === void 0 ? void 0 : (_entry_default_default = _entry_default1.default) === null || _entry_default_default === void 0 ? void 0 : (_entry_default_default_options = _entry_default_default.options) === null || _entry_default_default_options === void 0 ? void 0 : _entry_default_default_options.routes;
    throw new Error(`[one] route ${routeFile} is missing from the built server entry route map (looked in: ${Object.keys(routes !== null && routes !== void 0 ? routes : {}).join(", ")})`);
  }
  return exported;
}
//# sourceMappingURL=serverRouteModules.js.map
